import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Car, Gavel, HandshakeIcon, HandCoins, AlertCircle } from "lucide-react";
import Seo from "@/components/Seo";

export default function HowItWorksPage() {
  const steps = [
    { key: "list", icon: <Car className="h-8 w-8" />, title: "Avtomobilini auksiona çıxar", text: "Sadə formu doldur, şəkilləri yüklə və başlanğıc qiyməti təyin et." },
    { key: "bid", icon: <Gavel className="h-8 w-8" />, title: "Alıcılar qiymət təklif etsin", text: "Real-time təkliflər gəlir, son 2 dəqiqədə auksion avtomatik uzanır." },
    { key: "decide", icon: <HandCoins className="h-8 w-8" />, title: "Ən yüksək təklifi qəbul et", text: "Auksion bitəndə qərar sizindir. BƏLİ deyin və alıcı ilə əlaqə saxlayın." },
  ];
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-14 fade-in">
      <Seo title="Necə işləyir?" description="AzeAuksion.az-da avtomobil satmağın 3 sadə addımı: elan yerləşdir, təklifləri qəbul et, alıcı ilə əlaqə saxla." path="/how-it-works" />
      <div className="text-center max-w-2xl mx-auto">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50 text-blue-700 text-xs font-bold uppercase tracking-widest mb-4">Necə işləyir?</div>
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tighter text-slate-900">3 sadə addımda satış</h1>
        <p className="text-slate-600 mt-4 text-lg">Auksion.az sizi minlərlə alıcı ilə birləşdirir. Şəffaf təkliflər, sürətli əlaqə.</p>
      </div>
      <div className="mt-12 grid md:grid-cols-3 gap-6">
        {steps.map((s, i) => (
          <div key={s.key} className="p-8 rounded-2xl border border-slate-200 bg-white hover:border-blue-200 hover:shadow-lg transition-[box-shadow,border-color] duration-300">
            <div className="h-14 w-14 rounded-2xl bg-blue-100 text-blue-600 flex items-center justify-center mb-4">{s.icon}</div>
            <div className="text-xs uppercase tracking-widest text-slate-500 font-bold">Addım {i+1}</div>
            <h3 className="text-xl font-bold mt-1">{s.title}</h3>
            <p className="text-slate-600 mt-2">{s.text}</p>
          </div>
        ))}
      </div>
      <div className="mt-10 p-6 rounded-2xl bg-amber-50 border border-amber-200 flex gap-4">
        <AlertCircle className="h-6 w-6 text-amber-600 flex-shrink-0" />
        <div>
          <h4 className="font-bold text-slate-900">Vacib qeyd</h4>
          <p className="text-slate-700 mt-1">Platforma avtomobilin satışını özü həyata keçirmir. Auksion bitdikdən sonra son qərarı avtomobil sahibi verir. Ödəniş və mülkiyyət ötürülməsi tərəflər arasında baş verir.</p>
        </div>
      </div>
      <div className="text-center mt-10">
        <Link to="/sell"><Button size="lg" className="rounded-full bg-blue-600 hover:bg-blue-700 h-12 px-8 font-semibold">İndi başla</Button></Link>
      </div>
    </div>
  );
}
